import React from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  Box,
  Skeleton,
  Card,
  CardActionArea,
  useMediaQuery,
} from "@mui/material";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import { getProgramTemplateLibraryWidths } from "../program-library/ProgramsTableScreen";
import { SkeletonLoader } from "./ExerciseLibrarySkeletons";

const useStyles = makeStyles((theme) => ({
  actionArea: {
    padding: theme.spacing(3),
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1.5),
    },
    gap: theme.spacing(2),
    justifyContent: "start",
  },
  textContainer: {
    width: "60%",
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
  },
  mobileCard: {
    marginBottom: theme.spacing(2),
    boxShadow: theme.shadows[2],
  },
}));

interface ProgramLibraryTableSkeletonProps {
  className?: string;
}

export const ProgramLibraryTableSkeleton: React.FC<
  ProgramLibraryTableSkeletonProps
> = ({ className }) => {
  const columnWidths = getProgramTemplateLibraryWidths();
  const mdUp = useMediaQuery((theme) => theme.breakpoints.up("md"));
  return (
    <TableBody className={className}>
      <TableRow hover>
        <TableCell
          component="th"
          scope="row"
          sx={{ width: columnWidths.thumbnail }}
        >
          <Skeleton
            variant="rectangular"
            width={mdUp ? 70 : 120}
            height={60}
            sx={{ borderRadius: 1 }}
          />
        </TableCell>

        <TableCell
          component="th"
          scope="row"
          sx={{ width: columnWidths.title }}
        >
          <Box sx={{ width: "80%" }}>
            <Skeleton width={"80%"} />
            <Skeleton width={"100%"} />
          </Box>
        </TableCell>

        <TableCell align="center" sx={{ width: columnWidths.category }}>
          <SkeletonLoader width="60%" />
        </TableCell>

        <TableCell align="center" sx={{ width: columnWidths.privacy }}>
          <SkeletonLoader width="60%" />
        </TableCell>

        <TableCell align="center" sx={{ width: columnWidths.actions }}>
          <SkeletonLoader width={32} height={32} sx={{ mx: "auto" }} />
        </TableCell>
      </TableRow>
    </TableBody>
  );
};

interface ProgramLibraryCardSkeletonProps {
  className?: string;
}

export const ProgramLibraryCardSkeleton: React.FC<
  ProgramLibraryCardSkeletonProps
> = ({ className }) => {
  const styles = useStyles();
  const mdUp = useMediaQuery((theme) => theme.breakpoints.up("md"));
  return (
    <Card className={clsx(styles.mobileCard, className)}>
      <CardActionArea className={styles.actionArea}>
        <Skeleton
          variant="rectangular"
          width={mdUp ? 70 : 120}
          height={mdUp ? 70 : 120}
          sx={{ borderRadius: 1 }}
        />

        <Box className={styles.textContainer}>
          <Skeleton width="80%" height={22} sx={{ mb: 1 }} />
          <Skeleton width="60%" height={18} />
          <Skeleton width="100%" height={18} sx={{ mt: 1 }} />
        </Box>
      </CardActionArea>
    </Card>
  );
};
